export default "__VITE_ASSET__DUXKfFs4__"